import React from 'react';

interface BoardsListProps {
  onBack: () => void;
}

const BoardsList: React.FC<BoardsListProps> = ({ onBack }) => {
  const boards = ['Board 1', 'Board 2', 'Board 3'];

  return (
    <div className="relative flex flex-col items-center mt-10 w-full">
      <button
        onClick={onBack}
        className="absolute top-4 left-4 px-4 py-2 rounded text-white"
        style={{ backgroundColor: '#FF69B4' }}
      >
        Back to Dashboard
      </button>
      <h1 className="text-2xl font-bold mb-2 text-orange-500">Boards List</h1>
      <ul className="list-disc list-inside mb-4">
        {boards.map((board) => (
          <li key={board}>{board}</li>
        ))}
      </ul>
    </div>
  );
};

export default BoardsList;
